import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    caretButton: {
      width: '2rem',
      '&.MuiIconButton-root:hover': {
        backgroundColor: 'transparent',
      },
    },
    caretIconCollapsed: {
      transform: 'rotateX(180deg)',
    },
    title: {
      color: theme.palette.common.black,
    },
    headerContainer: {
      display: 'flex',
    },
  }),
);
